export interface ApiFlowrouteNumber {
  ISOCountry: string;
  Id: string;
  InboundRate: string;
  MonthlyCost: string;
  NumberType: string;
  RateCenter: string;
  RateType: string;
  SetupCost: string;
  State: string;
  Tier: string;
  Value: string;
}

export interface FlowrouteNumber {
  isoCountry: string;
  id: string;
  inboundRate: string;
  monthlyCost: string;
  numberType: string;
  rateCenter: string;
  rateType: string;
  setupCost: string;
  state: string;
  tier: string;
  value: string;
}

export function apiFlowrouteNumbersToFlowrouteNumbers(
  apiFlowrouteNumber: ApiFlowrouteNumber
): FlowrouteNumber {
  return {
    isoCountry: apiFlowrouteNumber.ISOCountry,
    id: apiFlowrouteNumber.Id,
    inboundRate: apiFlowrouteNumber.InboundRate,
    monthlyCost: apiFlowrouteNumber.MonthlyCost,
    numberType: apiFlowrouteNumber.NumberType,
    rateCenter: apiFlowrouteNumber.RateCenter,
    rateType: apiFlowrouteNumber.RateType,
    setupCost: apiFlowrouteNumber.SetupCost,
    state: apiFlowrouteNumber.State,
    tier: apiFlowrouteNumber.Tier,
    value: apiFlowrouteNumber.Value
  };
}
